<template>
  <div>
    <!-- Google's own failure is a grey box telling the reader to open the
         JavaScript console. Nobody running a school is going to do that, and
         the screen just looks broken - so the reason is said here instead,
         along with the one setting that fixes it. -->
    <v-alert
      v-if="mapsFailed"
      type="error"
      prominent
      text
      class="mb-0"
    >
      <div class="text-subtitle-1 font-weight-bold">{{ $t('maps_not_loading') }}</div>
      <div class="mt-2">{{ $t(fixKey) }}</div>
      <div v-if="mapsStatus.code" class="mt-2 text-caption">
        {{ $t('google_reported') }}: <code>{{ mapsStatus.code }}</code>
      </div>
      <div class="mt-2 text-caption">{{ $t('maps_meanwhile') }}</div>
    </v-alert>

    <GmapMap
      v-show="!mapsFailed"
      :center="center"
      :zoom="zoom"
      ref="mapp"
      style="width: 100%; height: 400px"
      @click="mark"
    >
      <gmap-info-window
        :options="infoOptions"
        :position="infoWindowPos"
        :opened="infoWinOpen"
        @closeclick="infoWinOpen = false"
      >
      </gmap-info-window>
      <GmapMarker
        :key="index"
        v-for="(m, index) in markers"
        :position="m.position"
        :icon="m.icon"
      />
      <gmap-polyline
          v-for="(p, index) in polylines"
          :path="p.data"
          :options="{ strokeColor: p.strokeColor, strokeWeight:5 }"></gmap-polyline>
    </GmapMap>
    <v-btn v-if="markers.length > 1" depressed color="success" @click="fitBounds" class="ma-1 float-right my-2">
      Fit
      <v-icon right dark>
        mdi-fit-to-screen-outline
      </v-icon>
    </v-btn>
  </div>
</template>
<script>
import { gmapApi } from "vue2-google-maps";
import { loadMaps, markMapsReady, mapsFixKey, mapsStatus } from "@/utils/googleMaps";

export default {
  props: {
    center: Object,
    zoom: Number,
    apiKey: String,
    markers: Array,
    selected: String,
    enabled: Boolean,
    polylines: []
  },
  data() {
    return {
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,

      infoOptions: {
        content: "",
        //optional: offset infowindow so it visually sits nicely on top of our marker
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
    };
  },
  watch: {
    markers: function (newVal, oldVal) {
      this.fitBounds();
    },
    selected: function (newVal, oldVal) {
      let selectedMarkerIndex = -1;
      for (let index = 0; index < this.markers.length; index++) {
        const marker = this.markers[index];
        if (marker.place_id == newVal) {
          selectedMarkerIndex = index;
          break;
        }
      }
      if (selectedMarkerIndex != -1) {
        this.toggleInfoWindow(
          this.markers[selectedMarkerIndex],
          selectedMarkerIndex
        );
      } else {
        this.infoWinOpen = false;
      }
    },
  },
  setup() {
    return { mapsStatus };
  },
  computed: {
    google: gmapApi,
    mapsFailed() {
      return this.mapsStatus.state === "failed";
    },
    fixKey() {
      return mapsFixKey();
    },
  },
  watch: {
    google(api) {
      if (api) markMapsReady();
    },
  },
  beforeMount() {
    if (this.google == null) {
      //loading, and what went wrong if it does not, is tracked centrally so
      //every screen can say the same thing
      loadMaps(this.apiKey);
    } else {
      markMapsReady();
    }
  },
  methods: {
    mark(event) {
      if(!this.enabled)
        return;

      const latlng = {
          lat: event.latLng.lat(),
          lng: event.latLng.lng(),
        };

      let geocoder = new google.maps.Geocoder();
      geocoder
        .geocode({ location: latlng })
        .then((response) => {
          if (response.results[0]) {
            this.$emit('map-click', response.results[0])
          } else {
            window.alert("No results found");
          }
        })
        .catch((e) => window.alert("Geocoder failed due to: " + e));
    },
    fitBounds() {
      if(this.markers.length == 1)
      return;
      var b = new google.maps.LatLngBounds();
      if (this.markers.length == 0) return;

      this.markers.forEach((marker) => {
        b.extend({
          lat: marker.position.lat,
          lng: marker.position.lng,
        });
      });
      this.$refs.mapp.fitBounds(b);
    },
    toggleInfoWindow: function (marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoOptions.content = marker.infoText;

      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },
  },
};
</script>
